/* eslint-disable react-hooks/exhaustive-deps */

import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Select from '../Select/Select';
import Input from '../Input/Input';
import { Context } from '../Context/withContext';
import { FormDataContext } from '../FormDataContext/WithFormDataContext';
import FormFullCol from '../FormFullCol/FormFullCol';
// import { vehicle_data } from '../../temp/vehicle_data';
import { PathContext } from '../PathContext/PathContext';
import { sendFinanceRequest } from '../VehiclePart3/Utils';
import { VehicleApplicationContext } from '../../VehicleApplicationContext/WithVehicleApplicationContext';
import { getVehicles } from './utils';

const schema = yup.object().shape({
  select_a_vehicle: yup.string().required('Required'),
});

const VehiclePart1 = ({ loading, setLoading }) => {
  const [stepNumber, setStepNumber] = useContext(Context);
  const [formData, setFormData] = useContext(FormDataContext);
  const [path] = useContext(PathContext);
  const [vehicleApplication, setVehicleApplication] = useContext(
    VehicleApplicationContext,
  );

  const [vehicle_data, setVehicleData] = useState([]);
  const [vehicle_names, setVehicle_names] = useState([]);

  React.useEffect(() => {
    console.log('Part 1');
  }, []);

  // useEffect(() => {
  //   const tempVehicleData = {};
  //   // vehicle_data.forEach((item) => {
  //   //   tempVehicleData.push(`${item.model} ${item.variation}`);
  //   // });
  //   vehicle_data.forEach((item) => {
  //     tempVehicleData[item.mmcode] = `${item.model} ${item.variation}`;
  //   });
  //   setVehicle_names(tempVehicleData);
  // }, [JSON.stringify(vehicle_names)]);

  useEffect(() => {
    getVehicles()
      .then((res) => {
        setVehicleData(res.data);
      })
      .catch((e) => {
        console.log('Error:', e);
      });
  }, []);

  useEffect(() => {
    const tempVehicleData = {};
    vehicle_data.forEach((item) => {
      if (formData.totalAffordableAmount) {
        if (item.retail_price <= formData.totalAffordableAmount) {
          tempVehicleData[item.mmcode] = `${item.model} ${item.variation}`;
        }
      } else {
        tempVehicleData[item.mmcode] = `${item.model} ${item.variation}`;
      }
    });
    console.log('tempVehicleData:', tempVehicleData);
    setVehicle_names(tempVehicleData);
  }, [JSON.stringify(vehicle_data)]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const getVehiclePrice = (code) => {
    let price;
    vehicle_data.forEach((item) => {
      if (item.mmcode === code) {
        price = item.retail_price;
        // price = 10;
      }
    });
    return price;
  };

  const getVehicleName = (code) => {
    let name;
    vehicle_data.forEach((item) => {
      if (item.mmcode === code) {
        name = `${item.model} ${item.variation}`;
      }
    });
    return name;
  };

  const sendRequest = () => {
    setLoading(true);
    let reqData = JSON.parse(JSON.stringify(formData));
    delete reqData.customerProfile.ethnicGroup;
    delete reqData.customerProfile.nationality;
    delete reqData.customerProfile.countryOfBirth;
    delete reqData.customerProfile.residentialAddress.yearsAtResidence;
    delete reqData.financeResponse;
    delete reqData.preApprovalId;
    delete reqData.totalAffordableAmount;
    delete reqData.monthlyInstallment;
    delete reqData.customerProfile.maritalContractCode;

    console.log('Part 1:', reqData);

    sendFinanceRequest(reqData)
      .then((res) => {
        // console.log(res);
        setLoading(false);
        setFormData((curr) => {
          return {
            ...curr,
            financeResponse: res.preApproval.preApprovalResults,
            financeMatrix: res.scoreGrid,
            preApprovalId: res.preApproval.preApprovalId,
            totalAffordableAmount: res.preApproval.totalAffordableAmount,
          };
        });
        setStepNumber(stepNumber + 1);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const onSubmit = (data) => {
    let curr = formData;
    curr.asset = {
      price: getVehiclePrice(data.select_a_vehicle),
      year: 2023,
      mmcode: data.select_a_vehicle.split('-').join(''),
      buyingType: 'D',
    };
    curr.preApproval = {
      preApprovalType: 'V',
    };

    setVehicleApplication(getVehicleName(data.select_a_vehicle));

    setFormData(curr);

    if (path === 'a') {
      sendRequest();
    } else {
      setStepNumber(stepNumber + 1);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormFullCol>
        {/* <h2 className="text-3xl uppercase font-bold my-12 text-suzBlue">
          Select a vehicle
        </h2> */}
        <Select
          register={register}
          label="Select a vehicle"
          errorMessage={errors.select_a_vehicle?.message}
          options={vehicle_names}
          required
        />
      </FormFullCol>
      <div className="flex justify-center mt-16">
        <Input type="submit" label="Next" />
      </div>
    </form>
  );
};

export default VehiclePart1;
